export default __webpack_public_path__ + "static/media/PauseButton.e955ca07.png";